import React from 'react';
import SATimePicker from "../common/input/SATimePicker";
import Constants from "../../services/Constants";
import {withAuthorization} from "../../services/Authorization";
import {injectIntl} from "react-intl";
import moment from 'moment';
import Storage from "../../services/Storage";
import GarbageButton from "../common/button/GarbageButton";
import PlusButton from "../common/button/PlusButton";

import './WeekDayTable.css';

class WeekDayTable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {}
  }

  onTimePickerUpdate = (time, weekDay, slotIndex, timeType) => {
    const {data} = this.props;
    data[weekDay].slots[slotIndex][timeType] = time ? moment(time).format("HH:mm") : undefined;

    if (!data[weekDay].slots[slotIndex].openTime && !data[weekDay].slots[slotIndex].closeTime) {
      this.onRemoveSlot(weekDay, slotIndex);
    }
    this.props.onChange(data);
  };

  onTimePickerChange = (time, weekDay, timeType) => {
    const {data={}} = this.props;
    const currentTime = time ? moment(time).format("HH:mm") : undefined;

    data[weekDay] = data[weekDay] || {};
    data[weekDay].slots = data[weekDay].slots || [];
    data[weekDay].slots.push({[timeType]: currentTime});
    this.props.onChange(data);
    this.setState({[weekDay]: false});
  };

  onAddSlot = (weekDay) => {
    this.setState({[weekDay]: true});
  };

  onRemoveSlot = (weekDay, slotIndex) => {
    const {data} = this.props;
    data[weekDay].slots.splice(slotIndex, 1);
    this.props.onChange(data);
  };

  renderDayWeek = (weekDay) => {
    const {intl: {formatMessage}, dataName, data={}, maxSlots, errors={}} = this.props;
    const user = Storage.getItem('user');
    const canWrite = user.role === 'DUI_ADMIN';
    const dayData = data[weekDay] || {};

    const dayWeek = [];

    if (dayData.slots && Object.keys(dayData.slots).length > 0) {
      dayData.slots.forEach((slot, index) => {
        let closeSlotError = errors[`${dataName}[${weekDay}].slots[${index}]`] || errors[`${dataName}[${weekDay}].slots[${index}].closeTime`];
        if (closeSlotError && closeSlotError.message === 'error.slot.invalid') {
          closeSlotError = {message: 'error.greater.or.equal', args: moment(slot.openTime, 'HH:mm').format('HH:mm')};
        }

        dayWeek.push(
          <li key={dayWeek.length}>
            <div className="row">
              <div className="column">
                <SATimePicker placeholder={formatMessage({id: "placeholder.startTime"})} value={slot.openTime} defaultOpenValue={slot.closeTime}
                              onChange={time => this.onTimePickerUpdate(time, weekDay, index, 'openTime')} disabled={!canWrite}
                              error={errors[`${dataName}[${weekDay}].slots[${index}].openTime`]}
                />
              </div>
              <div className="column">
                <SATimePicker placeholder={formatMessage({id: "placeholder.endTime"})} value={slot.closeTime} defaultOpenValue={slot.openTime}
                              onChange={time => this.onTimePickerUpdate(time, weekDay, index, 'closeTime')} disabled={!canWrite}
                              error={closeSlotError}
                />
              </div>
              <div className="column">
                {canWrite && (index === dayData.slots.length-1) && (dayData.slots.length < maxSlots) &&
                  <PlusButton onClick={() => this.onAddSlot(weekDay)}/>
                }
                {canWrite &&
                  <GarbageButton onClick={() => this.onRemoveSlot(weekDay, index)}/>
                }
              </div>
            </div>
          </li>
        )
      })
    }

    if (canWrite && (!dayData.slots || (dayData.slots && Object.keys(dayData.slots).length < 1) || this.state[weekDay])) {
      const slot = this.state[weekDay] || {};

      dayWeek.push(
        <li key={dayWeek.length}>
          <div className="row">
            <div className="column">
              <SATimePicker placeholder={formatMessage({id: "placeholder.startTime"})} value={slot.openTime} defaultOpenValue={'07:00'}
                            onChange={time => this.onTimePickerChange(time, weekDay, 'openTime')}/>
            </div>
            <div className="column">
              <SATimePicker placeholder={formatMessage({id: "placeholder.endTime"})} value={slot.closeTime} defaultOpenValue={'08:00'}
                            onChange={time => this.onTimePickerChange(time, weekDay, 'closeTime')}/>
            </div>
          </div>
        </li>
      )
    }
    return dayWeek;
  };

  renderWeek = () => {
    const {intl: {formatMessage}, dataName, errors={}} = this.props;
    const week = [];

    Constants.WEEK_DAY.forEach(weekDay => {
      const overlapError = errors[`${dataName}[${weekDay}]`];

      week.push(
        <div key={weekDay}>
          <div className="row">
            <div className="col-md-2 col-xxl-2">
              <label>{formatMessage({id: weekDay})}</label>
            </div>
            <div className="col-md-10 col-xxl-10">
              <ul className="unstyled-list weekday-list">
                {this.renderDayWeek(weekDay)}
                <li>
                  {overlapError && (
                    <div className={"txt-error"}>{formatMessage({id: overlapError.message}, {day: formatMessage({id: overlapError.args[0]})})}</div>
                  )}
                </li>
              </ul>

            </div>
          </div>
        </div>
      )
    });
    return week;
  };

  render() {
    return (
      <div>
        {this.renderWeek()}
      </div>
    )
  }
}

export default withAuthorization(injectIntl(WeekDayTable), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']);
